var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd12"},[_c('SupplierInfoCard',{on:{"login":_vm.handleLogin}}),_c('ShopGoodsList',{attrs:{"supplierCompanyId":_vm.supplierCompanyId},on:{"login":_vm.handleLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }